import { omit } from 'lodash';

import adjustUrlParams from './adjustUrlParams';

const removeParamsFromUrl = (url: string, paramsToRemove?: string[] | null) => {
  return adjustUrlParams(
    currentParams => omit(currentParams, paramsToRemove ?? []),
    url
  );
};

export default removeParamsFromUrl;
